import { Component, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { AuthService } from "./features/auth/services/auth.service";
import { PingService } from "./shared/services/ping.service";
import { IconService } from "./shared/services/icon.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { SharedModule } from "./shared/shared.module";
import { TitleComponent } from "./shared/components/title/title.component";
import { JustLogoComponent } from "./shared/components/just-logo/just-logo.component";
import { NgStyle } from "@angular/common";

@Component({
  selector: "app-root",
  standalone: false,
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  iconService = inject(IconService);
  router = inject(Router);
  authService = inject(AuthService);
  pingService = inject(PingService);

  offline = toSignal(this.pingService.offline$);

  constructor() {
    this.authService.checkBrowserCompatibility();
    this.iconService.initIcons();
  }

  compatibleBrowser = toSignal(this.authService.compatibleBrowser$);

  title = "JustUp";

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animationState"]
    );
  }

  onAdmin() {
    this.router.navigateByUrl("admin");
  }

  onGo(url: string) {
    window.open(url, "_blank");
  }
}
